<button
  [type]="type"
  class="search-btn"
  [disabled]="disabled"
  (click)="searchClick.emit()">
  <i class="fa fa-search"></i>
  {{ 'BUTTON.search' | translate }}
</button>
